import { render, staticRenderFns } from "./SfHeading.vue?vue&type=template&id=36b6d29c&functional=true&"
import script from "./SfHeading.vue?vue&type=script&lang=ts&"
export * from "./SfHeading.vue?vue&type=script&lang=ts&"
import style0 from "./SfHeading.vue?vue&type=style&index=0&id=36b6d29c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports